import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import creditRequestApi from "../../../api/creditRequestApi";

const CompanyCreditRequestModal = ({
  show,
  onClose,
  companyName,
  onSend,
  companyId,
  userEmail,
}) => {
  const [requestedCredits, setCreditsRequested] = useState("");
  const [message, setMessage] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [loading, setLoading] = useState(false);

  console.log("CompanyCreditRequestModal props:", {
    show,
    companyName,
    companyId,
  });

  const handleSubmitRequest = async () => {
    if (!requestedCredits || parseInt(requestedCredits, 10) <= 0) {
      toast.warn("Please enter a valid number of credits.");
      return;
    }
    const user = JSON.parse(localStorage.getItem("user"));
    const userEmail = user?.userEmail;
    if (!userEmail) {
      toast.error("User email not found. Please log in again.");
      return;
    }
    if (!mobileNumber || mobileNumber.trim() === "") {
      toast.warn("Please enter a valid mobile number.");
      return;
    }
    setLoading(true);
    try {
      const response = await creditRequestApi.saveCreditPricing({
        email: userEmail,
        userId: user?.userId,
        credits: parseInt(requestedCredits, 10),
        mobileNumber,
        companyId,
        frymeType: "BUSINESS",
        message,
      });
      console.log("Credit request response:", response);
      toast.success("Credit request submitted successfully!");
      // Reset form values
      setCreditsRequested("");
      setMessage("");
      onClose();
    } catch (error) {
      console.error("Error submitting credit request:", error);
      toast.error(
        error.response?.data?.message ||
          "An error occurred while submitting the credit request.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Request Credits for {companyName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div className="mb-3 p-2 border rounded bg-light">
          <p className="mb-1">
            <strong>Company ID:</strong> {companyId}
          </p>

          <p className="mb-1">
            <strong>Company Name:</strong> {companyName}
          </p>

          <p className="mb-0">
            <strong>User Email:</strong> {userEmail}
          </p>
        </div> */}
        <Form>
          <Form.Group controlId="mobileNumber">
            <Form.Label>
              Mobile Number <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="tel"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              placeholder="Enter your mobile number"
              required
            />
          </Form.Group>

          <Form.Group controlId="creditsRequested">
            <Form.Label>Credits Requested</Form.Label>
            <Form.Control
              type="number"
              value={requestedCredits}
              onChange={(e) => setCreditsRequested(e.target.value)}
              placeholder="Enter number of credits"
              min={1}
              required
            />
          </Form.Group>

          <Form.Group controlId="requestMessage" className="mt-3">
            <Form.Label>Optional Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Add any notes or justification..."
            />
          </Form.Group>

          <Button
            className="mt-3"
            variant="primary"
            onClick={handleSubmitRequest}
            disabled={loading || !mobileNumber || !requestedCredits}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </Form>
      </Modal.Body>
      <ToastContainer position="top-right" autoClose={3000} />
    </Modal>
  );
};

export default CompanyCreditRequestModal;
